import { render } from "./EditExpresso.vue?vue&type=template&id=bc8b9ffc"
import script from "./EditExpresso.vue?vue&type=script&lang=js"
export * from "./EditExpresso.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__